import {Injectable} from '@angular/core';
import {DcpConfigService} from '../dcp-config.service';
import {BehaviorSubject, Observable} from 'rxjs';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';

@UntilDestroy()
@Injectable({
  providedIn: 'root'
})
export class ForbiddenWordService {

  private forbiddenWords: string[] = [];
  private loadedSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(
    private dcpConfigService: DcpConfigService,
  ) {
    this.dcpConfigService.getForbiddenWords().pipe(untilDestroyed(this)).subscribe((data) => {
      this.forbiddenWords = data;
      this.loadedSubject.next(true);
    });
  }

  public checkForbiddenWords(str: string): boolean {
    if (typeof str !== 'string' || !str.length) {
      return false;
    }
    const strToUpperCase = str.toUpperCase();
    for (const word of this.forbiddenWords) {
      if (word === strToUpperCase) {
        return true;
      }
    }
    return false;
  }

  public loaded(): Observable<boolean> {
    return this.loadedSubject.asObservable();
  }
}
